import { openModal } from './index';
export const attachModalTrigger = ({ selector , id , ariaLabel , createVnode  })=>{
    const key = `__modalTriggerAttached_${selector}_${id || ''}`.replace(/[^a-zA-Z0-9_$]/g, '_');
    const win = window;
    if (win[key]) return ()=>undefined;
    const handler = (ev)=>{
        try {
            const path = ev.composedPath ? ev.composedPath() : [
                ev.target
            ];
            for (const node of path){
                if (!(node instanceof Element)) continue;
                const trigger = node.closest(selector);
                if (!trigger) continue;
                if (id) {
                    const attr = trigger.getAttribute('data-modal-open') || '';
                    if (attr !== id) continue;
                }
                ev.preventDefault();
                ev.stopPropagation();
                const vnode = createVnode(trigger, ev);
                if (!vnode) return;
                const modalSize = trigger.getAttribute('data-modal-size') || undefined;
                openModal(vnode, {
                    ariaLabel,
                    id,
                    category: modalSize
                });
                return;
            }
        } catch (err) {
            console.warn(`[modal] attachModalTrigger error for ${selector}`, err);
        }
    };
    window.addEventListener('click', handler, true);
    win[key] = handler;
    return ()=>{
        window.removeEventListener('click', handler, true);
        delete win[key];
    };
};
